import React, { useEffect } from "react";
import PortfolioUser from "./portfolio-user/PortfolioUser";
import { exportView } from "../../../navigation";
import { ContextProvider, environmentSwitch, translate } from "../../../common/providers";
import { PortfolioSpace } from "./portfolio-space";
import { useTrackEvent } from "../../../common/hooks";

const DashboardPortfolio = () => {
	const trackEvent = useTrackEvent();
	useEffect(() => {
		const documentTitle = translate("dashboard.document.title");
		document.title = documentTitle;
		if (ContextProvider.isLogged()) {
			environmentSwitch({
				main: ContextProvider.setHomeTab("projects"),
				veolia: ContextProvider.setHomeTab("espace"),
			});
		}
		trackEvent("Homepage_visit");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			{environmentSwitch({
				main: <PortfolioUser />,
				veolia: <PortfolioSpace />,
			})}
		</>
	);
};

export default exportView({
	path: "/",
	localesPath: "/dashboards/dashboard-portfolio/locales",
	component: DashboardPortfolio,
});
